/**
 * Timetastic
 * Logo component
 */
import React from "react"

// Styles
import "./logo.scss"

// JSX
const Logo = () => (
  <svg
    aria-label="Timetastic"
    className="c-logo"
    fill="currentColor"
    height="40"
    viewBox="0 0 1188 240"
    width="198"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="gradient" x1="0" y1="100%" x2="100%" y2="0">
        <stop offset="0%" stopColor="#E5007e" />
        <stop offset="15%" stopColor="#E5007e" />
        <stop offset="50%" stopColor="#995bc4" />
        <stop offset="85%" stopColor="#007ac9" />
        <stop offset="100%" stopColor="#007ac9" />
      </linearGradient>
    </defs>
    <use xlinkHref="#svg-logo" />
  </svg>
)

export default Logo
